<div class="image-editor-container">
    <tui-image-editor [options]="options"></tui-image-editor>
</div>
